import React from 'react';
import { Button, ButtonGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { GivingExamMode } from '../../../common/spdCore/validation/schemas';

export const ExamPreviewLink = (props: { examId: string; dark?: boolean }) => {
  return (
    <>
      <ButtonGroup aria-label="TestPlay">
        <OverlayTrigger
          overlay={<Tooltip>Obejrzyj oznaczone odpowiedzi </Tooltip>}
        >
          <Button
            onClick={e => {
              e.stopPropagation();
              window.open(
                `${process.env.REACT_APP_TEST_APP_URL}/?id=${props.examId}&mode=${GivingExamMode.PsychologistFast}`,
                'blank',
              );
            }}
            variant={props.dark ? 'outline-dark' : 'outline-primary'}
            className="mb-1"
          >
            <Icon.SkipForwardFill className={props.dark ? 'dark-icon' : ''} />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          overlay={
            <Tooltip>Obejrzyj badanie wypełnione przez badanego</Tooltip>
          }
        >
          <Button
            onClick={e => {
              e.stopPropagation();
              window.open(
                `${process.env.REACT_APP_TEST_APP_URL}/?id=${props.examId}&mode=${GivingExamMode.PsychologistFull}`,
                'blank',
              );
            }}
            variant={props.dark ? 'outline-dark' : 'outline-primary'}
            className="mb-1"
          >
            <Icon.SkipEndFill className={props.dark ? 'dark-icon' : ''} />
          </Button>
        </OverlayTrigger>
      </ButtonGroup>
    </>
  );
};
